import {call, put, takeLatest} from "redux-saga/effects";
import * as actions from "../action.constants";
import {
  getNotificationAsync,
  markAsReadAsync,
  markAllAsReadAsync,
  deleteNotificationsAsync,
} from "../AsyncActions/notifications.async";
import {saveNotifications} from "../Actions/notifications.action";

function* notificationsRequest() {
  try {
    const response = yield call(getNotificationAsync);
    if (response?.data) {
      yield put(saveNotifications(response?.data));
    }
  } catch (e) {
    return e;
  }
}

function* markAsRead(action) {
  try {
    const response = yield call(markAsReadAsync, action?.payload);
    if (response) {
      yield call(notificationsRequest);
    }
  } catch (e) {
    return e;
  }
}

function* markAllAsRead() {
  try {
    const response = yield call(markAllAsReadAsync);
    if (response) {
      yield call(notificationsRequest);
    }
  } catch (e) {
    return e;
  }
}

function* deleteNotifications(action = {}) {
  const {callback = () => {}} = action;
  try {
    const response = yield call(deleteNotificationsAsync);
    if (response) {
      callback();
      yield call(notificationsRequest);
    }
  } catch (e) {
    return e;
  }
}

export function* dashboardSaga() {
  yield takeLatest(actions.REQUEST_NOTIFICATIONS, notificationsRequest);
  yield takeLatest(actions.MARK_NOTIFICATION_READ, markAsRead);
  yield takeLatest(actions.MARK_ALL_NOTIFICATION_READ, markAllAsRead);
  yield takeLatest(actions.DELETE_NOTIFICATIONS, deleteNotifications);
}
